import OccupancyTab from "../../components/OccupancyTab";
import UtilityHeader from "../../components/headers/UtilityHeader";

export default function OccupancyManagement() {
  return (
    <main className="relative w-full max-w-7xl ">
      <UtilityHeader title={"occupancy management"} />
      <div className="w-full max-w-[1158px] mb-24 bg-hreen-500  ">
        <OccupancyTab />
      </div>
    </main>
  );
}
